export default "__VITE_ASSET__e9e584c8__"